export const parseToInt = (value) => parseInt(value.replace(/\D/g, ""), 10)
